function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h26v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#371447",
  d: "M1.11 6.86v1.608l11.766 3.474 11.906-3.474v-.886"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.95 6.504L12.585 4.1C5.156 5.71 1.415 6.52 1.364 6.529l-.262.607",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.597 5.751L8.256 8.884c-.214.058-.359.132-.434.22-.075.088-.129.248-.161.479V22.74l-2.111-.605V8.946c.033-.224.088-.419.165-.586.077-.167.331-.31.764-.429L16.642 5.25l1.955.501z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.069 5.715L17.41 8.848c.214.058.36.131.434.22.075.088.129.248.161.478v13.159l2.163-.728V8.787a2.172 2.172 0 00-.165-.586c-.076-.167-.33-.31-.763-.43L9.076 5.092l-2.007.624z",
  fill: "#FB8C00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.162 9.182v11.553l10.696 3.081 10.703-3.081V9.182l-10.7 3.082L2.162 9.182z",
  stroke: "#371447"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FB8C00"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.317 6.863c.058-.87.383-1.82.975-2.85C4.885 2.98 5.491 2.31 6.111 2c4.001 2.114 6.147 3.459 6.44 4.034.29.575.357.843.196.806-.258.326-.397.487-.415.485a46.763 46.763 0 00-4.221-.41c-1.053-.063-2.65-.08-4.794-.052z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.898 6.863c-.058-.87-.383-1.82-.975-2.85C20.33 2.98 19.724 2.31 19.104 2c-4.001 2.114-6.148 3.459-6.44 4.034-.291.575-.28.921.032 1.04.106.17.169.253.187.25a46.763 46.763 0 014.221-.409c1.053-.063 2.65-.08 4.794-.052z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.82 7.309l-.558-1.707c.302-.123.797-.182 1.483-.177.686.005 1.146.072 1.378.2l-.625 1.684c-.133.104-.388.156-.764.156-.377 0-.681-.052-.915-.156z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.917 24.011V13.49 24.01z",
  stroke: "#371447"
}));

function SvgOccasionsSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgOccasionsSm;